var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2266 0.186523H5.77344C2.86591 0.186523 0.5 2.55243 0.5 5.45996V30.9131C0.5 33.8206 2.86591 36.1865 5.77344 36.1865H16.3906V23.46H12.1719V17.1318H16.3906V12.8428C16.3906 9.35324 19.2292 6.51465 22.7188 6.51465H29.1172V12.8428H22.7188V17.1318H29.1172L28.0625 23.46H22.7188V36.1865H31.2266C34.1341 36.1865 36.5 33.8206 36.5 30.9131V5.45996C36.5 2.55243 34.1341 0.186523 31.2266 0.186523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.5 0.186523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.1b546701efb7f0c0d6f560b6474ea912.svg";
export { ForwardRef as ReactComponent };